import type { Chat } from '@/store/chats/IChats'
import { Divider, INewsChat } from '@/utils/IChats'
import { AlogixChat } from '@/store/alogixChat/alogixChat'
import { CustomChatNames } from '@/constants/CustomChats'

type TChat = Chat | Divider | INewsChat | AlogixChat

export const isChat = (chatOrDivider?: TChat | null): chatOrDivider is Chat => {
  return !!chatOrDivider && '$jid' in chatOrDivider
}

export const isDivider = (chatOrDivider?: TChat | null): chatOrDivider is Divider => {
  return !!chatOrDivider && 'name' in chatOrDivider && Object.keys(chatOrDivider).length === 1
}

export const isNewsChat = (chatOrDivider?: TChat | null): chatOrDivider is INewsChat => {
  return !!chatOrDivider && 'news' in chatOrDivider
}

export const isAlogixChat = (chatOrDivider?: TChat | null): chatOrDivider is AlogixChat => {
  return !!chatOrDivider && 'id' in chatOrDivider && chatOrDivider.id === CustomChatNames.ALOGIX
}
